export const deleteKeysFromObject = (obj, keysArrayToRemove = []) => {
    const keysSet = new Set(keysArrayToRemove);
    return Object.keys(obj).reduce((acc, key) => {
        if (!keysSet.has(key)) {
            acc[key] = obj[key];
        }
        return acc;
    }, {});
};
